const updateDisplayState = ( newState ) => ( {
    type: 'UPDATE_DISPLAY_STATE',
    data: newState,
} );

export  {
    updateDisplayState,
};
